import { getRuntimeConfig } from "@/config/runtimeConfig";

/**
 * Tenant-type detection.
 *
 * Resolution order:
 *   1. Explicit `VITE_AAD_TENANT_KIND` override (`ciam` | `workforce`).
 *      Required when the authority is a vanity custom domain whose
 *      hostname doesn't reveal the underlying Microsoft host (for
 *      example `login-test.kelowna.ca` → CIAM).
 *   2. Hostname heuristic against the configured authority /
 *      knownAuthority — looks for `*.ciamlogin.com` and
 *      `*.b2clogin.com`.
 *
 * The check must work synchronously at render time so the UI can
 * adapt immediately after config load — no Graph calls allowed here.
 */
export function isCiamTenant(): boolean {
  const cfg = getRuntimeConfig();

  if (cfg.tenantKind === "ciam") return true;
  if (cfg.tenantKind === "workforce") return false;

  const authority = cfg.authority.toLowerCase();
  const known = cfg.knownAuthority.toLowerCase();
  return (
    authority.includes(".ciamlogin.com") ||
    known.includes(".ciamlogin.com") ||
    authority.includes(".b2clogin.com") ||
    known.includes(".b2clogin.com")
  );
}
